import React from "react";

const Seo = (props) => {
  const { title, description, preventIndex = false } = props;

  const origin = process.env.GATSBY_ORIGIN;

  const COMPANY_NAME = {
    pt: "Alfredo AI",
    uk: "PropData",
    es: "PropData",
  };

  const IMAGE = {
    pt: "https://files-public.s3.fr-par.scw.cloud/website/alfredo_share_graphic.png",
    uk: "https://files-public.s3.fr-par.scw.cloud/website/propdata_share_graphic.jpg",
    es: "https://files-public.s3.fr-par.scw.cloud/website/propdata_share_graphic.jpg",
  };

  const URL = {
    pt: "https://alfredo.pt",
    uk: "https://propdata.uk",
    es: "https://propdata.es",
  };

  let DESCRIPTION = {
    pt: "Alfredo AI é uma plataforma de inteligência artificial projetada para ajudar os líderes da indústria imobiliária a tomar decisões baseadas em dados. Utilizando inferência estatística, big data e conhecimento especializado do setor, a nossa plataforma disponibiliza análises valiosas e otimiza a gestão de avaliações imobiliárias, disponibilizando aos nossos utilizadores as ferramentas necessárias para o sucesso.",
    uk: "PropData is an advanced Artificial Intelligence platform designed to assist real estate industry leaders in making data-driven decisions. Utilizing statistical inference, big data, and industry expertise, our platform provides valuable insights and streamlines real estate appraisal management processes, empowering users with the tools they need to succeed.",
    es: "PropData es una plataforma avanzada de inteligencia artificial diseñada para ayudar a los líderes de la industria inmobiliaria a tomar decisiones basadas en datos. Utilizando inferencia estadística, big data y conocimiento del sector, nuestra plataforma proporciona valiosas perspectivas y agiliza los procesos de gestión de tasaciones inmobiliarias, dotando a los usuarios de las herramientas necesarias para tener éxito.",
  };

  if (description) DESCRIPTION = description;

  return (
    <>
      <title>{`${COMPANY_NAME[origin]} - ${title[origin]}`}</title>
      <meta
        name="title"
        content={`${COMPANY_NAME[origin]} - ${title[origin]}`}
      />
      <meta name="description" content={DESCRIPTION[origin]} />
      <meta name="image" content={IMAGE[origin]} />
      <meta name="identifier-url" content={URL[origin]} />
      <meta
        name="keywords"
        content="Machine Learning, Artificial Intelligence, Data Science, Insights, Real Estate, Market Analytics, Appraisals, Automated Valuation Models AVM, Benchmarketing "
      />
      <meta
        name="og:title"
        content={`${COMPANY_NAME[origin]} - ${title[origin]}`}
      />
      <meta name="og:type" content="website" />
      <meta name="og:url" content={URL[origin]} />
      <meta name="og:image" content={IMAGE[origin]} />
      <meta
        name="og:site_name"
        content={`${COMPANY_NAME[origin]} - ${title[origin]}`}
      />
      <meta name="og:description" content={DESCRIPTION[origin]} />
      <meta name="google" content="notranslate" />
      <meta name="robots" content="notranslate" />
      <meta name="googlebot" content="notranslate" />

      {preventIndex && `<meta name="robots" content="noindex">`}
      {preventIndex && `<meta name="googlebot" content="noindex">`}
    </>
  );
};

export default Seo;
